<div class="custom-form">
    <div class="col-12 offset-1">
        <div class="card">
            <table class="table table-striped mt-1">
                <thead class="thead-dark">
                  <tr>
                    <th>{{ "Username" | translate }}</th>
                    <th>{{ "Description" | translate }}</th>
                    <th>{{ "Date" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of logHistoryArr">
                    <td>{{ item.creatorName }}</td>
                    <td> <div  [innerHTML]="item.description"></div>  </td>
                    <td>{{ item.createdOn | toDateTime }}</td>
                  </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
   